/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import { useScrollTrigger } from "@mui/material";
import React from 'react';
import Button from '../Button';
// import Appbar from "../Appbar/Appbar";
import { CgArrowDown } from 'react-icons/cg';
import { useScroll } from '../../utils/useScroll';
import { Colors } from "../../constants/color";
import { staticData } from "../../data/staticData";

function Header(): JSX.Element {
  // const threshold = useScrollTrigger({
  //   disableHysteresis: true,
  //   threshold: 400,
  // });
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        background: `url(${staticData.banner.imageSrc})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        userSelect: 'none',
      }}
      >
        {/* <Appbar
          sx={{
            position: threshold ? "fixed" : "static",
            top: 0,
            // transition: "position 1000ms ease",
          }}
        /> */}
        <Box
          sx={{
            width: '100%',
            height: 'calc(100vh - 81px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: Colors.white,
          }}
        >
          <Box
            sx={{
              // backgroundColor: "green",
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: "center",
              animationName: "animate-up",
              animationDuration: "1000ms",
              "@keyframes animate-up": {
                "from": {
                  opacity: 0,
                  transform: "translateY(150px)",
                },
                "to": {
                  opacity: 1,
                  transform: "translateY(0)",
                }
              }
            }}
          >
            <Typography
              variant='body1'
              sx={{
                fontSize: "18px",
                color: Colors.silver,
              }}
            >
              {staticData.banner.title}
            </Typography>
            <Typography
              variant='h6'
              sx={{
                fontSize: { xs: '28px', sm: '50px' },
                fontWeight: '700',
                textTransform: 'capitalize',
              }}
            >
              {staticData.banner.subtitle}
            </Typography>
            <Box
              sx={{
                marginTop: '18px',
              }}
            >
              <Button
                title="Start Scrolling"
                onClick={useScroll("next")}
                endIcon={<CgArrowDown style={{ marginLeft: '4px' }} />}
              />
            </Box>
          </Box>
        </Box>
    </Box>
  );
};

export default Header;
